export const aciSecurity = {
    iconName: 'security',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M6.334 10.598a.733.733 0 00-.734.734v9.333c0 .405.329.733.734.733h12a.733.733 0 00.733-.733v-9.333a.733.733 0 00-.733-.734h-12zm-1.934.734c0-1.068.866-1.934 1.934-1.934h12c1.067 0 1.933.866 1.933 1.934v9.333a1.933 1.933 0 01-1.933 1.933h-12A1.933 1.933 0 014.4 20.665v-9.333z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M12.333 2.598a4.067 4.067 0 00-4.067 4.067v3.333a.6.6 0 01-1.2 0V6.665a5.267 5.267 0 0110.534 0v3.333a.6.6 0 11-1.2 0V6.665a4.066 4.066 0 00-4.067-4.067zM12.334 14.066a.6.6 0 01.6.6v2.667a.6.6 0 01-1.2 0v-2.667a.6.6 0 01.6-.6z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
